<template>
  <div class="ui grid publico">
    <div class="wide column">
      <div class="ui centered grid">
        <div class="six wide tablet eight wide computer column">
          <img
            v-if="
              config.store &&
                config.store.setup &&
                config.store.setup.logo &&
                config.store.setup.logo.relative_path
            "
            :src="api_host + '/' + config.store.setup.logo.relative_path"
            class="ui image logotiendahead"
          />
        </div>
        <div class="six wide tablet eight wide computer column alng-right">
          <!-- <span class="blanco" v-if="config && config.store && config.store.setup">{{ config.store.setup.name }}</span> -->
          <span class="blanco logoheader nvidiasans-bold"
            >GeForce<sup
              >®</sup
            ></span
          >
        </div>
      </div>
      <div class="ui grid centered pt-1" v-show="bundles && bundles.length > 0">
        <div class="fourteen wide tablet twelve wide computer column">
          <div class="ui  container">
            <!-- <pre>{{ bundles }}</pre> -->
            <div class="my-slider" ref="slider">
              <div
                class="bgbundle "
                v-for="(bdle, bidx) in bundles"
                :key="bidx"
                :style="
                  'background: url(\'' +
                    api_host +
                    '/' +
                    bdle.bundle_image.relative_path +
                    '\');'
                "
                v-html="bdle.page.html"
              ></div>
            </div>
          </div>
          <div class="ui center aligned message">
            <div class="content blanco">
              <div class="header fsheader mb-2">
                Obtén tu código de juego
              </div>
              <p class="blanco">
                Para obtener tu código introduce la siguiente información:
              </p>
            </div>
          </div>
          <div class="ui form" ref="form">
            <div class="field">
              <label for="">{{ $t("name") }}</label>
              <input type="text" name="name" v-model="d.name" />
            </div>
            <div class="field">
              <label for="">{{ $t("email") }}</label>
              <input type="text" name="email" v-model="d.email" />
            </div>
            <div class="field">
              <label>{{ $t("gpu type") }}</label>
              <div class="ui selection dropdown" ref="gpu_type_dropdown">
                <input type="hidden" name="gpu_type" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="field">
              <label>{{ $t("brand") }}</label>
              <div class="ui selection dropdown" ref="brand_dropdown">
                <input type="hidden" name="brand" />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
            <div class="field">
              <label>{{ $t("card or notebook serial") }}</label>
              <input
                type="text"
                name="card_or_notebook_serial"
                placeholder=""
                v-model="d.card_or_notebook_serial"
              />
            </div>
            <div class="field">
              <label for="">{{ $t("bill or ticket number") }}</label>
              <input type="text" name="bill_number" v-model="d.bill_number" />
            </div>
            <div class="field">
              <label for="">{{ $t("upload image") }}</label>
              <file-pond
                name="bill_file"
                ref="file"
                :label-idle="$t('click or drop files here')"
                v-bind:allow-multiple="false"
                v-bind:allow-revert="false"
                v-bind:server="{
                  url: api_host,
                  timeout: enterprise_setup.upload_timeout,
                  process: {
                    url: '/nworkforce_exchange/public/do-upload',
                    method: 'POST',
                    headers: {
                      'x-access-token': token_session,
                    },
                    withCredentials: false,
                  },
                }"
                v-on:error="filepond_error"
                v-on:processfile="filepond_process"
              />
            </div>
            <div class="ui icon fluid toggle labeled teal button" @click="send">
              <i class="check icon"></i> {{ $t("send") }}
            </div>
            <div class="ui error message"></div>
          </div>
          <div class="ui center aligned message">
            <div class="content blanco mb-2">
              <p class="blanco">
                Si el código no te llegó al correo electrónico que ingresaste,
                revisa en la carpeta de correo no deseado.
              </p>
            </div>
            <div class="content blanco">
              <div
                class="ui inverted basic button"
                v-for="(bdl, bdidx) in bundles"
                :key="bdidx"
                @click="terms(bdl)"
              >
                Términos y condiciones
                <span v-if="bundles.length > 1">{{ bdl.name }}</span>
              </div>
            </div>
          </div>
          <hr class="lineaverde" />
          <div class="ui center aligned message">
            <div class="content blanco mb-2">
              <img
                class="logos"
                src="https://nworkforce.com/librerias/images/landing/logos/geforce.svg"
                alt="NVIDIA GEFORCE"
              />
            </div>
            <div class="content blanco legales">
              <p v-for="(bdl, bdidx) in bundles" :key="bdidx">
                {{ bdl.legals }}
              </p>
            </div>
          </div>
          <!-- <pre>{{ store }}</pre> -->
        </div>
      </div>
      <div
        class="ui grid centered pt-1"
        v-show="has_finished_loading && bundles && bundles.length == 0"
      >
        <div
          class="fourteen wide tablet twelve wide computer center aligned column"
        >
          <h3 class="fsheader font_geforce_light mb-2 blanco">
            LA TIENDA NO TIENE PROMOCIONES DISPONIBLES
          </h3>
          <hr class="lineaverde" />
          <div class="ui center aligned message">
            <div class="content blanco mb-2">
              <img
                class="logos"
                src="https://nworkforce.com/librerias/images/landing/logos/geforce.svg"
                alt="NVIDIA GeForce"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  enterprise_setup,
  api_host,
  success_toast,
} from "@/utils";
import { tns } from "tiny-slider";
import "tiny-slider/dist/tiny-slider.css";

export default {
  name: "NworkforceRedeemPublic",
  components: {},
  data() {
    return {
      config: { store: {} },
      store: { setup: {} },
      d: {
        name: "",
        email: "",
        bill_number: "",
        card_or_notebook_serial: "",
        gpu_type: "",
        brand: "",
        upload: {},
      },
      api_host: api_host,
      data: [
        '<div class="example-slide">Slide 1</div>',
        '<div class="example-slide">Slide 2</div>',
        '<div class="example-slide">Slide 3</div>',
      ],
      bundles: [],
      has_finished_loading: true,
    };
  },
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          name: ["empty"],
          bill_number: ["empty"],
          card_or_notebook_serial: ["empty"],
          email: ["empty", "email"],
        },
      });
    },
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    terms(bundle) {
      window.open(bundle.terms, "_blank");
    },
    send() {
      let vm = this;
      let id = vm.$route.query.i;
      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/nworkforce_exchange/public/do-save", {
          d: vm.d,
          s: id,
        })
          .then((/* r */) => {
            success_toast(vm.$t("request submitted"));
            vm.form.form("clear");

            let x1 = this.$refs.file;
            x1.removeFiles().then(() => {});
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) this.$alertify.error(r.error);
        else this.d.upload = r.data;
      }
    },
  },
  mounted() {
    let vm = this;
    let id = vm.$route.query.i;
    vm.has_finished_loading = false;
    local_api(vm, "post", "/nworkforce_exchange/public/do-init", { i: id })
      .then((r) => {
        vm.config = r;
        vm.has_finished_loading = false;

        /**
         * Limit GPU options
         */
        vm.bundles = vm.config.bundles.map((b) => {
          return b.setup;
        });

        let gpuBundleOpts = vm.bundles.reduce((prev, curr) => {
          return prev.concat(curr.graphic_cards_options);
        }, []);

        console.log("gpuBundleOpts", gpuBundleOpts);

        var gpus = vm.config.cards
          .map((c) => {
            return { name: c.setup.name, value: c.graphic_card_id, card: c };
          })
          .filter((i) => {
            let isInOpts = gpuBundleOpts.find((o) => {
              return String(o.card_id) == String(i.value) && o.laptop_available;
            });
            return isInOpts;
          });

        window
          .jQuery(vm.$refs.gpu_type_dropdown)
          .dropdown("setup menu", { values: gpus })
          .dropdown({
            onChange(value) {
              vm.d.gpu_type = value;
            },
          });

        var brands = vm.config.brands
          .map((c) => {
            return { name: c.setup.name, value: c.brand_id, brand: c };
          })
          .filter((i) => {
            return i.brand.setup.manufacture_card == true;
          });
        window
          .jQuery(vm.$refs.brand_dropdown)
          .dropdown("setup menu", { values: brands })
          .dropdown({
            onChange(value) {
              vm.d.brand = value;
            },
          });

        setTimeout(() => {
          // eslint-disable-next-line no-unused-vars
          var slider = tns({
            container: ".my-slider",
            mode: "gallery",
            items: 1,
            speed: 1000,
            swipeAngle: false,
            controls: false,
            slideBy: "page",
            autoplay: true,
          });
          // console.log(tns);
        }, 200);
      })
      .catch((err) => {
        error_toast(err);
      });
    // window.jQuery(vm.$refs.carrusel).owlCarousel();
  },
};
</script>

<style>
@import url("https://nworkforce.com/librerias/css/fonts/fonts.css");

.publico { background-color: black !important; /* height: inherit; */ margin-top: 0px !important; }
.publico .header,.blanco,
.publico label { color: white !important; }
.verde { color: rgb(118, 185, 0) !important; }
.filepond--drop-label label,
.negro { color: black !important; }
.pt-1 { padding-top: 5vw !important; }
.mb-2 { margin-bottom: 2vw !important; }
.font_geforce_bold { font-family: "geforce-bold" !important; }
.font_geforce_bold_a { font-family: "geforce-bold-notch" !important; }
.font_geforce_light { font-family: "geforce-light" !important; }
.font_geforce_light_a { font-family: "geforce-light-notch" !important; }
.fsheader { font-size: 42px !important; line-height: 42px; }
.logoheader { font-size: 3vw; line-height: 3vw; padding-right: 3vw; }
.alng-right { text-align: right !important; }
.logoheader sup { font-size: 50% !important; vertical-align: super; top: 0; }
.logotiendahead { max-height: 3.2vw; padding-left: 3vw; }
.message { background-color: transparent !important; border-radius: 0 !important; }
.lineaverde { border: 2px solid rgb(118, 185, 0); }
.logos { max-height: 50px; max-width: 170px; }
.legales { margin-bottom: 5%; text-align: left; color: #666; }
.legales p { font-size: 0.6em !important; }
.publico sup { font-size: 55% !important; }
.bgbundle { background-repeat: no-repeat !important; background-position: top right !important; background-size: contain !important; display: flex !important; flex-direction: row !important; }
.is-half { flex: none !important; display: block !important; width: 50% !important; padding: 0.7rem !important; }
.is-uppercase { text-transform: uppercase !important; }
.pt3 { padding-top: 3% !important; }
.fhb { font-family: "geforce-bold" !important; }
.fsh3 { font-family: "geforce-bold" !important; font-size: 42px !important; line-height: 42px !important; }
.pt1 { padding-top: 1% !important; }
.fsh5 { font-family: "geforce-bold" !important; font-size: 21px; line-height: 21px; }
.fsh5 label { display: unset; color: rgb(118, 185, 0) !important; }
.legal { padding: 0 6%; margin-bottom: 5%; display: block; font-size: 0.6rem; color: #666 !important; }
.alieal { text-align: left !important; }
.plless { padding-left: 0 !important; }
.pt5 { padding-top: 5% !important; }
.nvidiasans-reg { font-family: 'nvidiasans-regular' !important; }
.nvidiasans-reg-legal { font-family: 'nvidiasans-regular' !important; font-weight: normal !important; }
.nvidiasans-bold { font-family: 'nvidiasans-bold' !important; }
.nvidiasans-bold-itl { font-family: 'nvidiasans-bold-italic' !important; }
.nvidiasans-mid { font-family: 'nvidiasans-mid' !important; }
.nvidiasans-miditl { font-family: 'nvidiasans-midit' !important; }
.nvidiasans-reg-landing { font-family: 'nvidiasans-regular' !important; font-size: 21px !important; line-height: 21px !important; font-weight: normal !important; }
.nvidiasans-bold-landing { font-family: 'nvidiasans-bold' !important; font-size: 42px !important; line-height: 42px !important; }
</style>
